import { apiClient } from '@/app/api/client';
import { AxiosError } from 'axios';

export interface LLMCapabilities {
    chat: boolean;
    image: boolean;
    video: boolean;
}

export interface LLMConfig {
    provider: 'openai' | 'gemini';
    apiKey: string;
    enabled?: boolean;
    capabilities?: LLMCapabilities;
    isSystemDefault?: boolean;
    isTenantOwned?: boolean;
}

export interface LLMConfigUpdate {
    provider: 'openai' | 'gemini';
    apiKey: string;
    enabled?: boolean;
    capabilities?: LLMCapabilities;
}

class TenantLLMApiService {
    private handleError(error: unknown): never {
        if (error instanceof AxiosError && error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected API error occurred');
    }

    async getConfig(): Promise<LLMConfig> {
        try {
            const response = await apiClient.get<LLMConfig>('/api/tenant/llm-config');
            return response.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    async updateConfig(config: LLMConfigUpdate): Promise<{ success: boolean }> {
        try {
            const response = await apiClient.put<{ success: boolean }>('/api/tenant/llm-config', config);
            return response.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    async deleteConfig(): Promise<{ success: boolean }> {
        try {
            const response = await apiClient.delete<{ success: boolean }>('/api/tenant/llm-config');
            return response.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    async validateConfig(config: LLMConfigUpdate): Promise<{ success: boolean }> {
        try {
            const response = await apiClient.post<{ success: boolean }>('/api/tenant/llm-config/validate', config);
            return response.data;
        } catch (error) {
            this.handleError(error);
        }
    }
}

export const tenantLLMApi = new TenantLLMApiService();
export default tenantLLMApi;
